import classNames from "classnames";
import colors from "PFTheme/tokens/colors";
import React from "react";

import css from "./divider.module.scss";

type Color = keyof typeof colors;

type DividerProps = {
  theme?: {
    divider?: string;
  };
  type?: "horizontal" | "vertical";
  color?: Color;
};

export const Divider = ({ theme, type = "horizontal", color }: DividerProps) => (
  <div
    className={classNames(css.divider, theme?.divider, {
      [css.horizontal]: type === "horizontal",
      [css.vertical]: type === "vertical"
    })}
    style={
      color && {
        borderColor: `var(--${color})`
      }
    }
  />
);
